import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBitlyComponent } from './simple-icons-bitly.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBitlyComponent ],
    exports:      [ SimpleIconsBitlyComponent ],
    bootstrap:    []
})
export class SimpleIconsBitlyModule {}
